import React, {Component} from 'react';
import moment from 'moment';

import ToolTip from './components/tooltip';
import Legend from './components/legend';
import Selection from './components/selection';
import Days from './components/days.js';
import Months from './components/months.js';
import {HorizontalLines, VerticalLines} from './components/lines.js';
import Blocks from './components/blocks.js';

import {THEMES} from './constant';

import { format_si_number } from './utils/misc';

import s from './styles.module.css';
// import './styles.module.css';




function getWeek(date) {
  const current = new Date(date);
  var onejan = new Date(current.getFullYear(), 0, 1);
  var today = new Date(current.getFullYear(), current.getMonth(), current.getDate());
  var dayOfYear = ((today - onejan + 86400000)/86400000);
  return Math.ceil(dayOfYear/7);
};

const mapDataByUnit = (data) => {  
  const day_distribution_arr = data.map(d =>[moment(d.date, 'M/D/YYYY').dayOfYear() - 1, d.value]);
  const day_distribution = day_distribution_arr.reduce((obj, pair) => { obj[pair[0]] = pair[1]; return obj;}, {});

  let distributions = {}
  distributions.day = day_distribution;
  distributions.week = {}
  distributions.month = {}

  let prev_week = -1;
  let prev_month = -1;
  for (const i in data) {
    const current = data[i];

    let week = getWeek(current.date) - 1;
    if (prev_week !== week) {distributions.week[week] = 0;}
    prev_week = week;
    distributions.week[week] += current.value;

    let month = moment(current.date, 'M/D/YYYY').month();
    if (prev_month !== month) {distributions.month[month] = 0;}
    distributions.month[month] += current.value;
    prev_month = month;

  }
  return distributions;
}
const isLeapYear = (year) => {
  return (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0))
}
const yearCounts = (year) => {
  return {
    // minutes
    // hours
    // days
    // weeks
    // months
    // quarters
    day: isLeapYear(year)? 366 : 365,
    week: moment(year, 'YYYY').weeksInYear(),
    month: 12,
  };
}
const getFence = (data) => {
  const sorted = data.sort((a, b) => a - b);
  const lowerQIdx = Math.round(data.length / 4);
  const upperQIdx = Math.round(data.length / 4 * 3);
  const interQRange = sorted[upperQIdx] - sorted[lowerQIdx];
  const innerFence = [sorted[lowerQIdx] - interQRange * 1.5, sorted[upperQIdx] + interQRange * 1.5, ];
  const outerFence = [sorted[lowerQIdx] - interQRange * 3, sorted[upperQIdx] + interQRange * 3, ];
  const outOfInnerFence = data.filter(d => d < outerFence[0] || d > innerFence[1]);
  // do not make too many outliers
  if (outOfInnerFence.length < Math.sqrt(data.length / 5)) {
    return innerFence;
  } else {
    return outerFence;
  }
}
const getValueRange = (min, max) => {
  let newMax = max;
  //get chroma range: brew colors upto 7 or 8
  const minDiff = Math.floor((newMax - min) / 8).toString();
  //steps increase 1, 2, 5, 10, 20, 50, 100, 200, 5000, 1000 ...
  let step = 10;
  const firstDigit = parseInt(minDiff[0], 0);
  if (firstDigit === 0) {
    step = 1;
  } else if (firstDigit < 2) {
    step = 2;
  } else if (firstDigit < 5) {
    step = 5;
  }
  const distance = step * Math.pow(10, (minDiff.length - 1));

  //color step values
  let currentStep = 0;
  let steps = [];
  do {
    if (currentStep + distance > min) {
      steps.push(currentStep);
    }
    currentStep += distance;
  }
  while (currentStep < newMax + distance);

  return {min, max: newMax, steps, distance};
}
const getCalendar = (data, year) => {
  const byUnit = mapDataByUnit(data);
  // // console.log('byUnit');
  // // console.log(byUnit);
  // // console.log('---');
  const total = yearCounts(year);

  const units = ['day', 'week', 'month'];
  const byUnitArray =  units.map(unit => Object.entries(byUnit[unit]).map(d => d[1]));
  // // console.log('ua');
  // // console.log(byUnitArray);
  // // console.log('==');
  

  // get max vals and range by unit
  const maxByUnit = {};
  const rangeByUnit = {};
  for (const i in units) {
    const unit = units[i];
    const unitData = byUnit[unit];
    const maxVal = Math.max(...byUnitArray[i]);
    const minVal = Math.min(...byUnitArray[i]);

    // // console.log(unit + "--" + maxVal + '--' + minVal);

    // if negative number has in fact better meaning, get minimal data
    // const trueMaxVal = isReverse ? minVal : maxVal;
    const trueMaxVal = maxVal;

    let unitWithMax = [];
    for (const j in unitData) {
      if (unitData[j] === trueMaxVal) {
        unitWithMax.push(humanizeUnitId(year, unit, j));
      }
    }
    maxByUnit[unit] = {val: trueMaxVal, list: unitWithMax};
    // // console.log(maxByUnit);

    // get ranges that excludes outliers
    const outerFence = getFence(byUnitArray[i]);
    // // console.log(outerFence);
    // rangeByUnit[unit] = getValueRange(Math.max(minVal, outerFence[0]), Math.min(maxVal, outerFence[1]) );
    rangeByUnit[unit] = getValueRange(minVal, maxVal);
    // // console.log(rangeByUnit);
  }

  return {byUnit, total, max: maxByUnit, range: rangeByUnit};
}





const getMomentDay = (year, unit, id) => {
  return moment(year, 'YYYY').add(id, `${unit}s`);
}
const getDurationAcrossMonth = (sd, ed, isDay) => {
  //start day format
  let sf = 'MMMM D';
  //end day format
  let ef;
  if (isDay) {
    sf = 'ddd MMM D';
    ef = 'ddd MMM D';
  } else {
    ef = sd.format('M') === ed.format('M') ? `D` : `MMMM D`;
  }
  return `${sd.format(sf)} - ${ed.format(ef)}`;
}
const humanizeUnitId = (year, unit, id) => {
  const d = year != null ? getMomentDay(year, unit, id) : moment(id, 'M/D/YYYY');
  if (unit === 'day') {
    return d.format('ddd MMM D');
  } else if (unit === 'week') {
    const sd = d.startOf(id === 0 ? 'year' : 'week');
    const ed = sd.clone().add(6, 'days');
    return getDurationAcrossMonth(sd, ed);
  } else {
    return moment(+id + 1, 'M').format('MMMM');
  }
}




const getCalendarInfo = (year) => {
  const startDate = moment(`${year}0101`, 'YYYYMMDD');
  const endDate = moment(`${year}1231`, 'YYYYMMDD');
  const startWeek = startDate.clone().startOf('week');
  const endWeek = endDate.clone().add(7, 'day').startOf('week');
  const noOfWeeks = endWeek.diff(startWeek, 'weeks');

  return {
    startDay: startDate.day(),
    endDay: endDate.day(),
    noOfWeeks,
    year,
  };
}
const getDimensions = (year) => {

  const calendarInfo = getCalendarInfo(year);
  const {noOfWeeks} = calendarInfo;

  const containerW = 400 - 30;

  let margin = {
    legend: 20,
    top: 40,
    bottom: 8,
    left: 60,
    // right: 60,
  };

  const rectW = Math.max(Math.floor((containerW - margin.left) / noOfWeeks), 20);
  margin.right = rectW;
  const w = rectW * noOfWeeks;
  margin.left = Math.max(40, containerW - w - margin.right);

  return {
    rectW,
    margin,
    containerW,
    w: noOfWeeks * rectW,
    h: rectW * 7,
  };
}



export class Calendar extends Component {
  constructor(props) {
    super(props);
    
    this.rectHovered = this.rectHovered.bind(this);
    this.onUnitChange = this.onUnitChange.bind(this);

    this.state = {
      showToolTip: false,
      unit: 'day',
    };
  }

  onUnitChange(e) {
    this.setState({unit: e.target.value});
  }

  rectHovered(showToolTip, x, y, id, val, altVal) {
    // // // console.log('here = ' + showToolTip);
    this.setState({showToolTip, x, y, id, val, altVal});
  }

  render() {
    const {data, year, color, theme} = this.props;
    
    const theme_colors = (theme === 'dark')? THEMES.DARK_THEME: THEMES.LIGHT_THEME;
    
    const dims = getDimensions(year);
    const calInfo = getCalendarInfo(year);
    const calendar = getCalendar(data, year);
    // // console.log(calendar);

    const margin = dims.margin;
    
    // selection
    const unit = this.state.unit;
    const unit_options = [
      {'key': 'day', 'text': 'Day', },
      {'key': 'week', 'text': 'Week', },
      {'key': 'month', 'text': 'Month', },
    ]

    // console.log(data);    
    const filtered_details = data.filter(function(datum){ return datum['date'] === this.state.id}, this);
    // console.log(filtered_details);
    // console.log('-----');

    // tooltip
    const tt_x_pos = margin.left + this.state.x + (unit === 'day' && dims.rectW / 2) + (unit === 'month' && dims.rectW * 2);
    const tt_y_pos = margin.legend + margin.top + this.state.y + dims.rectW / 3;
    const tt_header = humanizeUnitId(unit === 'day' ? null : year, unit, this.state.id);
    let tt_body = [
      // (Math.round(this.state.val * Math.pow(10, 1)) / Math.pow(10, 1)).toLocaleString(),
      // (Math.round(this.state.val)).toLocaleString(),
      // this.state.id,
    ];
    if (filtered_details.length !== 0){
      for (let i = 0; i< filtered_details[0]['details'].length; i++){
        tt_body.push(filtered_details[0]['details'][i])
      }
    }
    // const tt_footer = "footer";
    const tt_footer = "Total: " + (Math.round(this.state.val * Math.pow(10, 1)) / Math.pow(10, 1)).toLocaleString();

    // legend
    const legend_steps = calendar.range[unit].steps.map(function(step, idx){return {'raw': step, 'formatted': format_si_number(step)}})
    const _maxRectW = (dims.containerW - margin.right * 2) / (legend_steps.length - 1);
    const legend_width = Math.min(_maxRectW, dims.rectW * 2);
    const legend_height = dims.rectW;

    return (
      <div className={''}  style={{ backgroundColor: theme_colors.bg }}>

        <div className={s.row}>
          <div className={s["col-xs-12"]}>
            <Selection theme_colors={theme_colors} selected={unit} options={unit_options} onSelect={this.onUnitChange} />
          </div>
        </div>

        <div className={s.row}>
          <div className={s['col-xs-12']}>
            <svg
              width={dims.w + margin.left + margin.right}
              height={dims.h + margin.legend + margin.top + margin.bottom}
            >
              <Blocks
                data={data}
                color={color}
                theme_colors={theme_colors} 
                
                rectW={dims.rectW}
                h={dims.h}
                margin={margin}
                
                calendar={calendar}
                year={year}
                unit={unit}
                rectHovered={this.rectHovered}
              />

              {unit === 'day' && <HorizontalLines theme_colors={theme_colors} {...dims} {...calInfo} />}
              {unit !== 'month' && <VerticalLines theme_colors={theme_colors} {...dims} {...calInfo} />}
              
              <Months pos_x={margin.left} pos_y={margin.legend + margin.top} theme_colors={theme_colors} {...dims} {...calInfo}/>
              <Days pos_x={margin.left} pos_y={margin.legend + margin.top} start_height={dims.rectW} theme_colors={theme_colors} />

              {this.state.showToolTip &&  <ToolTip theme_colors={theme_colors} header={tt_header} body={tt_body} footer={tt_footer} x_pos={tt_x_pos} y_pos={tt_y_pos} />}
            </svg>
          </div>

        </div>

        <div className={s.row}>
          <div className={s["col-xs-12"]}>
            <div className="" style={{textAlign: 'right', paddingTop: '10px'}}>
              <Legend theme_colors={theme_colors} height={legend_height} width={legend_width} steps={legend_steps} color={color} />
            </div>
          </div>
        </div>

      </div>
    );
  }
}
